import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import SendTemplateMessage from './SendTemplateMessage';


const SendTemplateManagement = () => {
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar: fixed height, non-scrollable */}
      <div className="h-screen  bg-gray-100 flex-shrink-0">
        <Sidebar />
      </div>

      {/* Main content: scrollable */}
      <div className="flex-1 overflow-y-auto bg-gray-100">
        <div className="p-">
          <SendTemplateMessage />
        </div>
      </div>
    </div>
  );
};

export default SendTemplateManagement;
